(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('PhoneCallPurpose', PhoneCallPurpose);

    PhoneCallPurpose.$inject = ['$resource'];

    function PhoneCallPurpose ($resource) {
        var resourceUrl =  'api/phone-call-purposes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
